export default __webpack_public_path__ + "static/media/close.7704b6d5.svg";